
interface TrelloWrapperProps {
  children: React.ReactNode;
}

export default function TrelloWrapper({ children }: TrelloWrapperProps) {
  return <div className="l-trello-wrapper">{children}</div>;
}
